import { Text } from '@/components/text';

import type { PropsWithChildren, ReactNode } from 'react';

type PlanDetailItemProps = PropsWithChildren<{
  subHeading?: ReactNode;
}>;

const PlanDetailItem = ({ children, subHeading }: PlanDetailItemProps) => {
  if (!children) {
    return null;
  }

  return (
    <div>
      <Text
        variant="h2"
        as="p"
        className="text-product-plan-card-accent"
      >
        {children}
      </Text>
      {subHeading}
    </div>
  );
};

export { PlanDetailItem };
